import { Component, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { Params } from '@angular/router';

import { BaseWidget } from '../../BaseWidget/BaseWidget.component';
import { Events } from '../../../../services/DisplayStateService';
import { Guid } from '../../../../classes/Guid';
import { SideNavWidgetConfig, SideNavList, ConflictViewer } from '../../../../interfaces/DisplayInterfaces';
import { NameValue, WidgetConfiguration, DataPolicy } from '../../../../interfaces/WidgetInterfaces';
import { UtilityFunctions } from '../../../../classes/UtilityFunctions';
import * as _ from 'lodash';
import { DisplayStateService } from '../../../../services/DisplayStateService';
import { AppStateService } from '../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../services/ClientSettingsService';

@Component({
  selector: 'app-master-configuration',
  template: `<div class="container-fluid">

    <div class="row">
        <div *ngIf="Ready()" class="col-sm-4 ">
            <div class="col-xs-12">
                <input type="text" class="form-control mb-3" [ngModel]="filter" (ngModelChange)="onLocalFilterChange($event)" placeholder="Search"
                />
            </div>
            <div class="pc-sidenav">
                <div class="card mb-3 ">
                    <div class="card-header d-flex justify-content-between">
                        <h5 class="m-0">Side Navigation</h5>
                        <button type="button" class="btn btn-success btn-sm" (click)="toggleCollapse('s')">
                            <i class="fa fa-arrows-v"></i>
                        </button>
                    </div>
                    <ul [collapse]="isCollapsed('s')" class="list-group ">
                        <li (click)="UserSelect('SideNav', sideNavNV.name)" class="list-group-item justify-content-between {{IsActive('SideNav', sideNavNV.name)}}"
                            *ngFor="let sideNavNV of filteredSideNavWidgetConfig.widgetNameList; let idx = index" [ngClass]="{'modifiedColor': sideNavNV?.modified}">
                            <div>{{sideNavNV.name}}</div>
                            <h6>
                                <span class="badge badge-default" *ngIf="sideNavNV?.unSavedData">UNSAVED</span>
                            </h6>
                        </li>
                    </ul>
                </div>
                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between">
                        <h5 class="m-0">Widget Configuration</h5>
                        <div>
                            <button type="button" class="btn btn-info btn-sm" (click)="Add('WidgetConfiguration')">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-info btn-sm" (click)="toggleCollapse('w')">
                                <i class="fa fa-arrows-v"></i>
                            </button>
                        </div>
                    </div>
                    <ul [collapse]="isCollapsed('w')" class="list-group">
                        <li (click)="UserSelect('WidgetConfiguration', WidgetConfiguration.name)" class="list-group-item justify-content-between {{IsActive('WidgetConfiguration', WidgetConfiguration.name)}}"
                            *ngFor="let WidgetConfiguration of filteredWidgetConfigurationList; let idx = index" [ngClass]="{'modifiedColor': WidgetConfiguration?.modified}">
                            <span class="float-sm-left">{{WidgetConfiguration.name}} </span>

                            <span class="float-sm-right">
                                <span class="badge badge-default" *ngIf="WidgetConfiguration?.unSavedData">UNSAVED</span>
                                <button type="button" class="btn btn-sm btn-secondary" *ngIf="CanAddWidgetConfigAsSideNav(WidgetConfiguration)" (click)="AddWidgetConfigAsSideNav(WidgetConfiguration)">Side Nav</button>
                            </span>
                        </li>

                    </ul>
                </div>

                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between">
                        <h5 class="m-0">Data Policy</h5>
                        <div>
                            <button type="button" class="btn btn-warning btn-sm" (click)="Add('DataPolicy')">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>

                            <button type="button" class="btn btn-warning btn-sm" (click)="toggleCollapse('d')">
                                <i class="fa fa-arrows-v"></i>
                            </button>
                        </div>

                    </div>
                    <ul [collapse]="isCollapsed('d')" class="list-group">
                        <li (click)="UserSelect('DataPolicy', DataPolicy.name)" class="list-group-item justify-content-between {{IsActive('DataPolicy', DataPolicy.name)}}"
                            *ngFor="let DataPolicy of filteredDataPolicyList; let idx = index " [ngClass]="{'modifiedColor': DataPolicy?.modified}">
                            <span class="float-sm-left">{{DataPolicy.name}}</span>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
        <div class="col-sm-8">
            <div *ngIf="selectedSideNav">
                <div class="card card-outline-success mb-2">
                    <div class="card-block">
                        <div class="d-flex justify-content-between mb-4">
                            <h4 class="card-title">Side Navigation: {{selectedSideNav.name}}</h4>
                            <div class="save-button-wrapper" *ngIf="!readOnlySideNavigation">
                                <button class="btn btn-primary" (click)="onSaveDb({typeName : 'SideNav', widget: selectedSideNav})">Save DB</button>
                                <button class="btn btn-success" (click)="onModified({typeName : 'SideNav', widget: selectedSideNav})">Locally</button>
                                <div dropdown class="dropdown action-group">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" dropdownToggle data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu  dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" type="button" (click)="getFreshAndReset('SideNav')">Reset</button>
                                        <button class="dropdown-item" type="button" (click)="Remove('SideNav', selectedSideNav.name)"> Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="alert alert-info" role="alert" *ngIf="readonlyWidget">
                            <strong>Heads up!</strong> This is a Read Only widget.
                        </div>
                        <tabset [justified]="true">
                            <tab heading="Properties">
                                <div class="form-group row">
                                    <label for="name" class="col-sm-2 col-form-label">Display Name</label>
                                    <div class="col-sm-10">
                                        <input type="text" class="form-control" [(ngModel)]="selectedSideNav.value" name="value" [disabled]="readOnlySideNavigation">
                                    </div>
                                </div>
                            </tab>
                            <tab heading="Raw">
                                <pre>{{filteredSideNavWidgetConfig | json}}</pre>
                            </tab>
                        </tabset>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedWidgetConfiguration">
                <div class="card card-outline-info mb-2">
                    <div class="card-block">
                        <div class="d-flex justify-content-between mb-4">
                            <h4 class="card-title">Widget Configuration: {{selectedWidgetConfiguration.name}}</h4>
                            <div class="save-button-wrapper" *ngIf="!readOnlyWidget">
                                <button class="btn btn-primary" (click)="onSaveDb({typeName : 'WidgetConfiguration', widget: selectedWidgetConfiguration})">Save DB</button>
                                <button class="btn btn-success" (click)="onModified({typeName : 'WidgetConfiguration', widget: selectedWidgetConfiguration})">Locally</button>
                                <div dropdown class="dropdown action-group">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" dropdownToggle aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu  dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <button type="button" class="dropdown-item" (click)="getFreshAndReset('WidgetConfiguration')">Reset</button>
                                        <button type="button" class="dropdown-item" (click)="CloneselectedWidgetConfiguration()">Clone</button>
                                        <button type="button" class="dropdown-item" (click)="Remove('WidgetConfiguration', selectedWidgetConfiguration.name)"> Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <app-widget-config-editor [selectedWidgetConfig]="selectedWidgetConfiguration"></app-widget-config-editor>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedDataPolicy">
                <div class="card card-outline-warning mb-2">
                    <div class="card-block">
                        <div class="d-flex justify-content-between mb-4">
                            <h4 class="card-title">Data Policy: {{selectedDataPolicy.name}}</h4>
                            <div class="save-button-wrapper">
                                <button class="btn btn-primary" (click)="onSaveDb({typeName : 'DataPolicy', widget: selectedDataPolicy})">Save DB</button>
                                <button class="btn btn-light" (click)="getFreshAndReset('DataPolicy')">Reset</button>
                                <div dropdown class="dropdown action-group">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" dropdownToggle data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    </button>
                                    <div *dropdownMenu class="dropdown-menu  dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                        <button type="button" class="dropdown-item" (click)="CloneselectedDataPolicy()">Clone</button>
                                        <button type="button" class="dropdown-item" (click)="Remove('DataPolicy', selectedDataPolicy.name)"> Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <app-data-policy-editor [selectedDataPolicy]="selectedDataPolicy"></app-data-policy-editor>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #diffCompareModal>
        <div class="modal-header">
            <h4 class="modal-title pull-left">Conflict Viewer </h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-block">
                            <h3 class="card-title">Data base Copy</h3>

                            <pre>{{conflictViewerFullData.data.dbCopy | json}}</pre>
                            <button class="btn btn-primary" (click)="saveDBAfterConflict('db')">Save</button>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-block">
                            <h3 class="card-title">Your Copy</h3>
                            <pre>{{conflictViewerFullData.data.userCopy | json}}</pre>
                            <button class="btn btn-primary" (click)="saveDBAfterConflict('user')">Save</button>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-block">
                            <h3 class="card-title">Diff</h3>
                            <pre [innerHTML]="diffBetweenConfigs"></pre>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </ng-template>`,
  styles: [`.list-group-item{
    cursor:pointer;
}
.btn-sm{
    padding:1px;
    padding-left:8px;
    padding-right:8px;
}

.modifiedColor{
    background-color:#f4b942
}

:host ::ng-deep tabset .tab-content{
    padding:15px;
    padding-top:25px;
}

.list-group-item{
    border-left:none;
    border-right:none;
}

.list-group-item:first-child{
    border-top:none;
}

.list-group-item:last-child{
    border-bottom:none;
}

.action-group .dropdown-toggle::after{
    display:none;
}

.action-group{
    display:inline-block;
}
.action-group .dropdown-menu{
    background-color:white;
    
}
.pc-sidenav{
    overflow-y:auto;
    height:calc(100vh - 252px);
}
.action-group .dropdown-item{
    color:#292b2c;
    text-align:center;
}
.action-group .dropdown-item:hover{
    background-color:#f7f7f9;
}`]
})
export class MasterConfigurationComponent extends BaseWidget {

  private dataChangedFlag = 'modified';

  // Master lists
  dataPolicyList: DataPolicy[];
  widgetConfigurationList: WidgetConfiguration[];
  sideNavWidgetConfig: SideNavWidgetConfig;

  // Filtered Lists
  filteredDataPolicyList: DataPolicy[];
  filteredWidgetConfigurationList: WidgetConfiguration[];
  filteredSideNavWidgetConfig: SideNavWidgetConfig;

  // Selected Items
  selectedDataPolicy: DataPolicy;
  selectedWidgetConfiguration: WidgetConfiguration;
  selectedSideNav: SideNavList;

  sideNavListCollapsed = false;
  widgetConfigListCollapsed = false;
  dataPolicyListCollapsed = false;
  // Unique identifer for this widget instance
  guid: Guid;

  filter = '';
  showGlobalSaveBtn = false;
  readOnlySideNavigation = false;
  readOnlyWidget = false;

  conflictViewerFullData: ConflictViewer;
  dbDateModified: string;

  diffBetweenConfigs: any;
  modalReftemplate: any;

  @ViewChild('diffCompareModal') diffCompareModal: TemplateRef<any>;

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }

  onModified({ typeName, widget }) {
    switch (typeName) {
      case 'SideNav':
        delete widget['unSavedData'];
        // check to see the service has the widget
        const sideNavIndx = this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.findIndex(x => x.name === widget.name);
        // if there is not widget in the service just add it and move.
        let sideNavCopy: SideNavList = <SideNavList>{};
        Object.keys(widget).map(x => sideNavCopy[x] = widget[x]);
        if (sideNavIndx < 0) {
          widget.modified = true;
          this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.push(sideNavCopy);
        } else {
          widget.modified = true;
          this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.splice(sideNavIndx, 1, sideNavCopy);
        }
        this.displayStateService.RaiseSuccessToast(`${widget.name} Saved Locally.`);
        break;
      case 'WidgetConfiguration':
        delete widget['unSavedData'];
        widget.modified = true;
        // check to see the service has the widget
        let widgetServiceDataIndex = this.displayStateService.appState.widgetConfigList.findIndex(data => data.name === widget.name);
        // if there is not widget in the service just add it and move.
        let widgetCopy: WidgetConfiguration = <WidgetConfiguration>{};
        Object.keys(widget).map(x => widgetCopy[x] = widget[x]);
        if (widgetServiceDataIndex < 0) {
          this.displayStateService.appState.widgetConfigList.push(widgetCopy);
        } else {
          this.displayStateService.appState.widgetConfigList.splice(widgetServiceDataIndex, 1, widgetCopy)
        }
        this.displayStateService.RaiseSuccessToast(`${widget.name} Saved Locally.`);
        break;
    }
  }


  onSaveDb({ typeName, widget }) {
    let { modified, unSavedData, ...widgetConfig } = widget;

    switch (typeName) {
      case 'SideNav':
        this.webPlatformApiService.SaveSingleConfiguration('SideNavWidgetConfigList', widgetConfig, widgetConfig.name)
          .subscribe(x => {
            if (x.status === 'conflict') {
              this.conflictConfigReader('SideNav', x);
            } else {
              this.sideNavConfigReader(x.data);
            }
          }, error => this.displayStateService.RaiseErrorToast(error));

        break;
      case 'WidgetConfiguration':
        this.webPlatformApiService.SaveSingleConfiguration('WidgetConfigurationList', widgetConfig, widgetConfig.name)
          .subscribe(x => {
            if (x.status === 'conflict') {
              this.conflictConfigReader('WidgetConfiguration', x);
            } else {
              this.widgetConfigReader(x.data);
            }
          }, error => this.displayStateService.RaiseErrorToast(error));
        break;
      case 'DataPolicy':
        this.webPlatformApiService.SaveSingleConfiguration('DataPolicyList', widgetConfig, widgetConfig.name).subscribe(x => {
          if (x.status === 'conflict') {
            this.conflictConfigReader('DataPolicy', x)
          } else {
            this.dataPolicyConfigReader(x.data);
          }
        }, error => this.displayStateService.RaiseErrorToast(error));
        break;
    }
  }

  conflictConfigReader(category: string, compare: any) {
    let full = {
      category: category,
      widgetName: compare.data.dbCopy.name,
      modifiedDbDate: compare.data.dbCopy.dateModified,
      data: compare.data
    };
    this.triggerWhenSaveConflit(full);
  }

  sideNavConfigReader(widget: SideNavList) {
    const sideNavIndx = this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.findIndex(data => data.name === widget.name);
    if (sideNavIndx >= 0) {
      this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.splice(sideNavIndx, 1, JSON.parse(JSON.stringify(widget)))
    } else {
      this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.push(JSON.parse(JSON.stringify(widget)));
    }
    this.sideNavWidgetConfig.widgetNameList = this.sideNavWidgetConfig.widgetNameList
      .map(data => data.name === widget.name ? widget : data);
    this.UserSelect('SideNav', widget.name);
    this.displayStateService.RaiseSuccessToast(`${widget.name} Saved to Data base.`);
  }

  widgetConfigReader(widget: WidgetConfiguration) {
    const widgetIndx = this.displayStateService.appState.widgetConfigList.findIndex(data => data.name === widget.name)
    if (widgetIndx >= 0) {
      this.displayStateService.appState.widgetConfigList.splice(widgetIndx, 1, JSON.parse(JSON.stringify(widget)));
    } else {
      this.displayStateService.appState.widgetConfigList.push(JSON.parse(JSON.stringify(widget)));
    }
    this.widgetConfigurationList = this.widgetConfigurationList.map(data => data.name === widget.name ? widget : data);
    this.selectedSideNav ? this.UserSelect('SideNav', this.selectedSideNav.name)
      : this.UserSelect('WidgetConfiguration', this.selectedWidgetConfiguration.name);
    this.displayStateService.RaiseSuccessToast(`${widget.name} Saved to Data base.`);

  }

  dataPolicyConfigReader(widget: DataPolicy) {
    this.dataPolicyList = this.dataPolicyList.map(data => data.name === widget.name ? widget : data);

    if (this.selectedSideNav) {
      this.UserSelect('SideNav', this.selectedSideNav.name);
    } else if (this.selectedWidgetConfiguration) {
      this.UserSelect('WidgetConfiguration', this.selectedWidgetConfiguration.name)
    } else {
      this.UserSelect('DataPolicy', this.selectedDataPolicy.name)
    }
    this.displayStateService.RaiseSuccessToast(`${widget.name} Saved to Data base.`);
  }

  triggerWhenSaveConflit(x: ConflictViewer) {
    this.conflictViewerFullData = Object.assign({}, x);
    delete this.conflictViewerFullData.data.dbCopy['dateModified'];
    delete this.conflictViewerFullData.data.userCopy['dateModified'];
    this.diffBetweenConfigs = this.displayStateService
      .GetJsonDiffHtml(this.conflictViewerFullData.data.dbCopy, this.conflictViewerFullData.data.userCopy);
    this.modalReftemplate = this.displayStateService.OpenModal(this.diffCompareModal, 'modal-lg');
  }

  saveDBAfterConflict(level: string) {
    let selectedData;
    this.hideModal();
    if (level === 'user') {
      selectedData = this.conflictViewerFullData.data.userCopy;
    } else {
      selectedData = this.conflictViewerFullData.data.dbCopy;
    }
    selectedData.dateModified = this.conflictViewerFullData.modifiedDbDate;
    this.onSaveDb({ typeName: this.conflictViewerFullData.category, widget: selectedData });
  }

  onLocalFilterChange(newValue: string) {
    this.displayStateService.AddFilter('configSearch', newValue);
  }

  hideModal() {
    this.displayStateService.HideModal(this.modalReftemplate);
  }

  onFiltersChanged(currentFilters: Params) {
    const found = Object.keys(currentFilters).find(k => k === 'configSearch');
    if (found !== undefined) {
      this.filter = currentFilters['configSearch'].toLowerCase();
    } else {
      this.filter = '';
    }
    this.ApplyFilter();
  }

  ApplyFilter() {
    this.filteredDataPolicyList = this.dataPolicyList ?
      this.dataPolicyList.filter(dp => dp.name.toLowerCase().indexOf(this.filter) > -1) :
      [];

    if (this.filteredSideNavWidgetConfig) {
      this.filteredSideNavWidgetConfig.widgetNameList = this.sideNavWidgetConfig && this.sideNavWidgetConfig.widgetNameList ?
        this.sideNavWidgetConfig.widgetNameList.filter(n => n.name.toLowerCase().indexOf(this.filter) > -1) :
        [];

    }

    this.filteredWidgetConfigurationList = this.widgetConfigurationList ?
      this.widgetConfigurationList.filter(wc => wc.name.toLowerCase().indexOf(this.filter) > -1) :
      [];
  }

  onInitialize() {
    this.guid = Guid.newGuid();
    this.InitializeSideNav();
    this.InitializeWidgetConfig();
    this.InitializeDataPolicy();
  }

  onStateChanged(eventName: string) {
    // If this widget is displayed right when the app starts, the display state service may not have gotten all its config retrieved
    if (eventName === Events.SIDE_NAV_CHANGED) {
      this.InitializeSideNav();
    } else if (eventName === Events.WIDGET_CONFIG_LIST_CHANGED) {
      this.InitializeWidgetConfig();
    }
  }

  toggleCollapse(initial: string) {
    if (initial.toLowerCase() === 's') {
      return this.sideNavListCollapsed = !this.sideNavListCollapsed;
    } else if (initial.toLowerCase() === 'w') {
      return this.widgetConfigListCollapsed = !this.widgetConfigListCollapsed;
    } else if (initial.toLowerCase() === 'd') {
      return this.dataPolicyListCollapsed = !this.dataPolicyListCollapsed;
    }
  }

  isCollapsed(initial: string): boolean {
    if (initial.toLowerCase() === 's') {
      return this.sideNavListCollapsed;
    } else if (initial.toLowerCase() === 'w') {
      return this.widgetConfigListCollapsed;
    } else if (initial.toLowerCase() === 'd') {
      return this.dataPolicyListCollapsed;
    }
  }

  InitializeSideNav() {
    if (this.displayStateService.appState.sideNavWidgetConfig) {
      const json = JSON.stringify(this.displayStateService.appState.sideNavWidgetConfig);
      this.sideNavWidgetConfig = JSON.parse(json);
      this.filteredSideNavWidgetConfig = JSON.parse(json);
    }
    this.onFiltersChanged(this.displayStateService.appState.current.filters);
  }

  InitializeWidgetConfig() {

    const full = this.displayStateService.AddRequiredWidgetsTo(this.displayStateService.appState.widgetConfigList);
    const json = JSON.stringify(full);
    this.widgetConfigurationList = [...JSON.parse(json)];

    this.filteredWidgetConfigurationList = [...JSON.parse(json)];
    this.onFiltersChanged(this.displayStateService.appState.current.filters);
  }

  InitializeDataPolicy() {
    this.webPlatformApiService.GetConfig<DataPolicy[]>('DataPolicyList').subscribe(x => {

      const json = JSON.stringify(x);
      this.filteredDataPolicyList = JSON.parse(json);
      this.dataPolicyList = JSON.parse(json);
      this.onFiltersChanged(this.displayStateService.appState.current.filters);
    });
  }

  Ready() {
    return this.dataPolicyList !== undefined &&
      this.widgetConfigurationList !== undefined &&
      this.sideNavWidgetConfig !== undefined;
  }

  IsActive(typeName: string, itemName: string) {
    if (!this.IsSelected(typeName, itemName)) {
      return '';
    } else {
      if (typeName === 'SideNav') { return 'list-group-item-success'; }
      if (typeName === 'WidgetConfiguration') { return 'list-group-item-info'; }
      if (typeName === 'DataPolicy') { return 'list-group-item-warning'; }
      return '';
    }
  }

  IsSelected(typeName: string, itemName: string): boolean {
    if (!this.Ready()) { return false; }
    if (typeName === 'SideNav') { return this.selectedSideNav && this.selectedSideNav.name === itemName; }
    // tslint:disable-next-line:max-line-length
    if (typeName === 'WidgetConfiguration') { return this.selectedWidgetConfiguration && this.selectedWidgetConfiguration.name === itemName; }
    if (typeName === 'DataPolicy') { return this.selectedDataPolicy && this.selectedDataPolicy.name === itemName; }
    return false;
  }

  Add(typeName: string) {
    if (typeName === 'DataPolicy') { this.AddPolicy(); }
    if (typeName === 'WidgetConfiguration') { this.AddWidgetConfiguration(); }
    this.ApplyFilter();
  }


  Remove(typeName: string, itemName: string) {
    if (typeName === 'SideNav') {
      this.sideNavWidgetConfig.widgetNameList.splice(this.sideNavWidgetConfig.widgetNameList.findIndex(x => x.name === itemName), 1);
      const localNavIndx = this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.findIndex(x => x.name === itemName);
      this.selectedSideNav = undefined;
      if (localNavIndx) {
        this.displayStateService.appState.sideNavWidgetConfig.widgetNameList.splice(localNavIndx, 1);
        this.selectedSideNav = undefined;
        this.webPlatformApiService.RemoveSingleConfig('SideNavWidgetConfigList', itemName).subscribe(x => {
          this.RemoveResponse(x);
        });
      }
    }
    if (typeName === 'DataPolicy') {
      this.dataPolicyList.splice(this.dataPolicyList.findIndex(x => x.name === itemName), 1);
      this.selectedDataPolicy = undefined;
      this.webPlatformApiService.RemoveSingleConfig('DataPolicyList', itemName).subscribe(x => {
        this.RemoveResponse(x);
      });
    }
    if (typeName === 'WidgetConfiguration') {
      this.widgetConfigurationList.splice(this.widgetConfigurationList.findIndex(x => x.name === itemName), 1);
      const localwidgetIndx = this.displayStateService.appState.widgetConfigList.findIndex(x => x.name === itemName);
      this.selectedWidgetConfiguration = undefined;
      if (localwidgetIndx >= 0) {
        this.displayStateService.appState.widgetConfigList.splice(localwidgetIndx, 1);
        this.selectedWidgetConfiguration = undefined;
        this.webPlatformApiService.RemoveSingleConfig('WidgetConfigurationList', itemName).subscribe(x => {
          this.RemoveResponse(x);
        });
      }

    }
    this.ApplyFilter();
  }

  RemoveResponse(res) {
    if (res.status === 'success') {
      this.displayStateService.RaiseSuccessToast(`${res.data} Deleted`)
    } else if (res.status === 'Not Found') {
      this.displayStateService.RaiseToast(`${res.data} Not Found`);
    }
  }


  UserSelect(typeName: string, itemName: string) {
    if (this.selectedSideNav) {
      this.checkSideNavSavedLocally();
      if (this.selectedWidgetConfiguration) {
        this.checkWidgetSavedLocally();
      }
    } else if (this.selectedWidgetConfiguration) {
      this.checkWidgetSavedLocally();
    }

    this.selectedDataPolicy = undefined;
    this.selectedWidgetConfiguration = undefined;
    this.selectedSideNav = undefined;

    this.Select(typeName, itemName);
  }

  checkSideNavSavedLocally() {
    let { unSavedData, modified, dateModified, ...removedFlags } = this.selectedSideNav;
    let localMemoryData = Object.assign({}, this.displayStateService.appState.sideNavWidgetConfig.widgetNameList
      .find(data => data.name === removedFlags.name));
    if (!_.isEmpty(localMemoryData)) {
      delete localMemoryData['dateModified'];
      delete localMemoryData['modified'];
      delete localMemoryData['unSavedData'];
    }

    JSON.stringify(localMemoryData) !== JSON.stringify(removedFlags) &&
      !this.displayStateService.IsByDefaultSideNav(this.selectedSideNav.name)
      ? this.selectedSideNav.unSavedData = true : this.selectedSideNav.unSavedData = false;
  }
  checkWidgetSavedLocally() {
    let { unSavedData, modified, dateModified, ...removedFlags } = this.selectedWidgetConfiguration;
    let localMemoryData = Object.assign({}, this.displayStateService.appState.widgetConfigList
      .find(data => data.name === removedFlags.name));
    if (!_.isEmpty(localMemoryData)) {
      delete localMemoryData['dateModified'];
      delete localMemoryData['modified'];
      delete localMemoryData['unSavedData'];
      if (localMemoryData.dataConsumerConfiguration && !localMemoryData.dataConsumerConfiguration.overrideCustomHeaders
        && removedFlags.dataConsumerConfiguration.overrideCustomHeaders
        && removedFlags.dataConsumerConfiguration.overrideCustomHeaders.length === 0) {
        delete removedFlags.dataConsumerConfiguration['overrideCustomHeaders'];
      }
    }

    const localChanged = _.isEqual(localMemoryData, removedFlags);
    !localChanged && !this.displayStateService.IsByDefaultWidget(this.selectedWidgetConfiguration.name) ?
        this.selectedWidgetConfiguration.unSavedData = true : this.selectedWidgetConfiguration.unSavedData = false;
  }

  Select(typeName: string, itemName: string) {
    this.PublishItemSelectedMessage(typeName, itemName);
  }

  PublishItemSelectedMessage(name: string, value: string) {
    const messageParams: Params = [];
    messageParams[`selected.${name}`] = value;
    this.displayStateService.MessageHouse.next(messageParams);
  }

  onNewMessage(msgParams: Params) {
    if (!this.Ready()) { return; }
    if (msgParams['selected.DataPolicy'] !== undefined) {
      this.SetSelectedDataPolicyFromMessage(
        this.dataPolicyList.find(dp => dp.name === msgParams['selected.DataPolicy'])
      );
    } else if (msgParams['selected.SideNav'] !== undefined) {
      this.SetSelectedSideNavFromMessage(
        this.sideNavWidgetConfig.widgetNameList.find(nv => nv.name === msgParams['selected.SideNav'])
      );

    } else if (msgParams['selected.WidgetConfiguration'] !== undefined) {
      this.SetSelectedWidgetConfigFromMessage(
        this.widgetConfigurationList.find(wc => wc.name === msgParams['selected.WidgetConfiguration'])
      );
    }
    this.ApplyFilter();
  }

  SetSelectedSideNavFromMessage(item: NameValue) {
    this.selectedSideNav = item;
    if (this.selectedSideNav !== undefined) {
      this.readOnlySideNavigation = this.displayStateService.IsByDefaultSideNav(this.selectedSideNav.name);
      this.Select('WidgetConfiguration', this.selectedSideNav.name);
    }
  }

  SetSelectedWidgetConfigFromMessage(item: WidgetConfiguration) {
    this.selectedWidgetConfiguration = item;

    if (this.selectedWidgetConfiguration !== undefined) {
      this.readOnlyWidget = this.displayStateService.IsByDefaultWidget(item.name);
      UtilityFunctions.InitializeDataConsumerConfigForEdit(this.selectedWidgetConfiguration.dataConsumerConfiguration);

      if (this.selectedWidgetConfiguration.dataConsumerConfiguration &&
        this.selectedWidgetConfiguration.dataConsumerConfiguration.dataPolicy) {
        this.Select('DataPolicy', this.selectedWidgetConfiguration.dataConsumerConfiguration.dataPolicy);
      }
    }
  }

  SetSelectedDataPolicyFromMessage(item: DataPolicy) {
    this.selectedDataPolicy = item;
    if (this.selectedDataPolicy !== undefined) {
      if (this.selectedDataPolicy.fixedParameters === undefined) {
        this.selectedDataPolicy.fixedParameters = [];
      }

      if (this.selectedDataPolicy.columnRenameMap === undefined) {
        this.selectedDataPolicy.columnRenameMap = [];
      }

    }
  }

  CloneselectedWidgetConfiguration() {
    if (this.selectedWidgetConfiguration) {
      const copy = <WidgetConfiguration>JSON.parse(JSON.stringify(this.selectedWidgetConfiguration));
      copy.name += ' CLONE';
      this.widgetConfigurationList.push(copy);
      this.Select('WidgetConfiguration', copy.name);
    }
  }

  CloneselectedDataPolicy() {
    if (this.selectedDataPolicy) {
      const copy = <DataPolicy>JSON.parse(JSON.stringify(this.selectedDataPolicy));
      copy.name += ' CLONE';
      this.dataPolicyList.push(copy);
      this.Select('DataPolicy', copy.name);
    }
  }

  AvailableSideNavWidgetNames(): NameValue[] {
    return this.widgetConfigurationList
      .map(wc => wc.name)
      .filter(name => name === this.selectedSideNav.name ||
        this.sideNavWidgetConfig.widgetNameList.findIndex(nv => nv.name === name) === -1)
      .map<NameValue>(n => { return { name: n, value: n }; });
  }


  CanAddWidgetConfigAsSideNav(wc: WidgetConfiguration): boolean {
    return this.sideNavWidgetConfig !== undefined &&
      this.sideNavWidgetConfig.widgetNameList.findIndex(x => x.name === wc.name) === -1;
  }

  AddWidgetConfigAsSideNav(wc: WidgetConfiguration) {
    this.sideNavWidgetConfig.widgetNameList.push({ name: wc.name, value: wc.name });
  }

  AddWidgetConfiguration() {
    this.widgetConfigurationList.push(
      {
        name: 'New Widget',
        description: 'Enter description here',
        supportMessage: 'Enter support message here',
        componentType: 'Name that will be used in platform to refer to this widget',
        config: {},
        dataConsumerConfiguration: {
          dataPolicy: '',
          fixedParameters: [],
          sortColumns: [],
          contextParameters: [],
          filterConfiguration: [],
          overrideCacheRules: { period: undefined },
          dataGrouping: undefined
        },
        contextMatchingRules: []
      }
    );

    this.Select('WidgetConfiguration', 'New Widget');
  }

  AddPolicy() {
    const newPolicy: DataPolicy = {
      name: '(NEW POLICY)',
      supportMessage: '',
      supportGroup: '',
      supportNameList: '',
      sourceURL: '',
      CacheRules: { period: 'hour', frequency: 2 },
      fixedParameters: [],
      columnRenameMap: []
    };
    this.dataPolicyList.push(newPolicy);
    this.selectedDataPolicy = newPolicy;
    this.Select('DataPolicy', newPolicy.name);
  }


  getFreshAndReset(typeName) {
    switch (typeName) {
      case 'SideNav':
        this.webPlatformApiService.GetConfig<SideNavWidgetConfig>('SideNavWidgetConfigList').subscribe(
          sideNavWidgetConfig => {
            let currentData = sideNavWidgetConfig.widgetNameList.find(data => data.name === this.selectedSideNav.name);
            if (currentData) {
              this.sideNavWidgetConfig.widgetNameList = this.sideNavWidgetConfig.widgetNameList
                .map(data => data.name === this.selectedSideNav.name ? currentData : data);
              this.displayStateService.appState.sideNavWidgetConfig.widgetNameList = this.displayStateService.appState
                .sideNavWidgetConfig.widgetNameList.map(data => data.name === currentData.name ? Object.assign({}, currentData) : data);
              this.UserSelect(typeName, this.selectedSideNav.name);
              this.displayStateService.RaiseSuccessToast(`${this.selectedSideNav.name} Side Navigation is upto date.`);
            } else {
              this.displayStateService.RaiseWarnToast(`${this.selectedSideNav.name} is not saved to the Database.`);
            }

          },
          error => this.appStateService.appendLog('LoadSideNavConfigList ERROR: ' + JSON.stringify(error), 1)
        );
        break;
      case 'WidgetConfiguration':
        this.webPlatformApiService.GetConfig<WidgetConfiguration[]>('WidgetConfigurationList').subscribe(x => {
          let currentData = x.find(data => data.name === this.selectedWidgetConfiguration.name);
          if (currentData) {
            this.widgetConfigurationList = this.widgetConfigurationList
              .map(data => data.name === this.selectedWidgetConfiguration.name ? Object.assign({}, currentData) : data);
            this.displayStateService.appState.widgetConfigList = this.displayStateService.appState.widgetConfigList
              .map(data => data.name === currentData.name ? JSON.parse(JSON.stringify(currentData)) : data);
            this.selectedSideNav ? this.UserSelect('SideNav', this.selectedSideNav.name)
              : this.UserSelect(typeName, this.selectedWidgetConfiguration.name);
            this.displayStateService.RaiseSuccessToast(`Your ${this.selectedWidgetConfiguration.name} Widget Configuration is upto date.`);
          } else {
            this.displayStateService.RaiseWarnToast(`${this.selectedWidgetConfiguration.name} is not saved to the Database.`);
          }

        });
        break;
      case 'DataPolicy':
        this.webPlatformApiService.GetConfig<DataPolicy[]>('DataPolicyList').subscribe(x => {
          let currentData = x.find(data => data.name === this.selectedDataPolicy.name);
          if (currentData) {
            this.dataPolicyList = this.dataPolicyList.map(data => data.name === this.selectedDataPolicy.name ? currentData : data);
            if (this.selectedSideNav) {
              this.UserSelect('SideNav', this.selectedSideNav.name);
            } else if (this.selectedWidgetConfiguration) {
              this.UserSelect('WidgetConfiguration', this.selectedWidgetConfiguration.name)
            } else {
              this.UserSelect(typeName, this.selectedDataPolicy.name)
            }
            this.displayStateService.RaiseSuccessToast(`${this.selectedDataPolicy.name}  Data Policy is upto date.`)
          } else {
            this.displayStateService.RaiseWarnToast(`${this.selectedDataPolicy.name} is not saved to the Database.`);
          }

        })
        break;
    }
  }
}
